export interface PagePreviewPattern {
  pattern: string;
  skillName: string;
  bg: string;
  fg: string;
  accent: string;
  direction: string;
  keywords: string[];
  requiredInfo: string[];
  sensitiveInfo: string[];
}

export const PAGE_PREVIEW_PATTERNS: PagePreviewPattern[] = [
  {
    pattern: "trust",
    skillName: "顔出し・信頼メッセージ型",
    bg: "#f7fafc",
    fg: "#17264a",
    accent: "#1f5fbf",
    keywords: ["相続", "遺言", "帰化", "永住", "相談", "個人"],
    requiredInfo: ["代表者名・登録番号・所属会", "代表メッセージ", "相談しやすさの根拠", "掲載可能なお客様の声"],
    sensitiveInfo: ["実名・顔写真掲載の可否", "お客様の声の掲載許可", "相談実績の件数"],
    direction:
      "代表者の顔、実名、登録番号、所属会、地域へのメッセージを大きく見せる。長い代表挨拶、相談しやすさ、お客様の声を強く出す。",
  },
  {
    pattern: "authority",
    skillName: "専門家集団・実績権威型",
    bg: "#eef2ff",
    fg: "#18264f",
    accent: "#3347c5",
    keywords: ["建設", "産廃", "経審", "法人", "難案件", "実績"],
    requiredInfo: ["許可取得・相談対応の実績", "難案件に対応できる根拠", "法人向けサポート範囲", "料金・顧問/継続支援の方針"],
    sensitiveInfo: ["実績件数", "許可取得を保証しない表現", "料金の正式掲載可否"],
    direction:
      "許可取得件数、法人対応、難案件、専門チーム、出版・登壇などを強く見せる。安さではなく専門性で選ばせる構成。",
  },
  {
    pattern: "problem",
    skillName: "不安代弁・ストーリー型",
    bg: "#fff8ef",
    fg: "#2a2118",
    accent: "#c47a2c",
    keywords: ["不安", "失敗", "不許可", "何から", "必要書類", "自分で"],
    requiredInfo: ["よくある不安", "過去に多い不備・失敗例", "相談後に解決できること", "初回相談で確認する内容"],
    sensitiveInfo: ["不許可・失敗事例の掲載可否", "許可見込みの断定禁止", "料金の目安"],
    direction:
      "検索者の不安を物語として見せる。悩み、失敗例、行政書士が入ることで解決する流れ、吹き出しや漫画風のコマ割りを入れる。",
  },
  {
    pattern: "corporate",
    skillName: "法人許認可・即決CVR型",
    bg: "#eef6f2",
    fg: "#12332a",
    accent: "#15805f",
    keywords: ["建設", "産廃", "会社", "飲食", "営業許可", "法人", "更新"],
    requiredInfo: ["対応できる手続き範囲", "料金・納期・追加費用条件", "必要書類", "更新・変更届など継続支援の可否"],
    sensitiveInfo: ["料金表", "納期の断定可否", "対応不可ケース"],
    direction:
      "法人担当者がすぐ比較できるよう、料金、納期、必要書類、対応範囲、更新・変更届までの継続支援をページ上部から出す。",
  },
  {
    pattern: "price",
    skillName: "料金明示・即問い合わせ型",
    bg: "#f8fbff",
    fg: "#172033",
    accent: "#0f76b7",
    keywords: ["料金", "費用", "車庫", "古物", "会社設立", "飲食店"],
    requiredInfo: ["基本料金", "法定費用・実費", "追加料金が発生する条件", "申込みから完了までの流れ"],
    sensitiveInfo: ["税込/税別", "料金改定の可能性", "キャンセル・追加費用条件"],
    direction:
      "料金表、合計費用例、追加料金条件、納期、必要書類、申込導線を前面に出す。比較検討中の人が即決しやすい構成。",
  },
  {
    pattern: "local",
    skillName: "地域・管轄攻略型",
    bg: "#f6fbf5",
    fg: "#223022",
    accent: "#4f8f52",
    keywords: ["福岡", "市", "区", "警察署", "農業委員会", "管轄", "地域"],
    requiredInfo: ["対応地域", "管轄窓口・地域固有の注意点", "近隣地域対応", "地域での相談事例"],
    sensitiveInfo: ["窓口情報の更新日", "対応できない地域", "地域実績の有無"],
    direction:
      "対応地域、管轄窓口、地域固有の注意点、近隣エリアへのリンクを見せる。地元の実在感を重視する。",
  },
  {
    pattern: "familiar",
    skillName: "地域の親近感型",
    bg: "#fffdf7",
    fg: "#302820",
    accent: "#b6723a",
    keywords: ["地域", "相談", "相続", "個人", "親しみ"],
    requiredInfo: ["相談しやすさの具体例", "地域との関わり", "対応時間・相談方法", "新人/若手なら長く担当できる強み"],
    sensitiveInfo: ["顔出し可否", "土日夜間対応の条件", "料金の出し方"],
    direction:
      "作り込みすぎず、少し素朴で相談のハードルが低い印象にする。地域密着の写真、やさしい文章、手書き風の案内を使う。",
  },
  {
    pattern: "message_story",
    skillName: "大量メッセージ・理念ストーリー型",
    bg: "#fbf7f0",
    fg: "#2c241d",
    accent: "#8a5a2b",
    keywords: ["代表", "想い", "理念", "不安", "相続", "帰化"],
    requiredInfo: ["開業理由", "相談者への約束", "大切にしている対応方針", "印象に残っている相談エピソード"],
    sensitiveInfo: ["実際の相談事例の匿名化", "誇張表現の禁止", "本人メッセージの掲載確認"],
    direction:
      "事務所の想い、開業理由、相談者への約束を長文メッセージで読ませる。整ったカードよりも読み物として信頼を積む。",
  },
  {
    pattern: "manga",
    skillName: "漫画・図解解説型",
    bg: "#fff7fb",
    fg: "#2f2230",
    accent: "#d54a8a",
    keywords: ["建設", "在留", "補助金", "難しい", "流れ", "初めて"],
    requiredInfo: ["相談者ペルソナ", "よくあるつまずき", "漫画で説明したい手続きの流れ", "先生キャラクターの役割"],
    sensitiveInfo: ["制度説明の正確性", "料金の掲載可否", "実績・事例の掲載許可"],
    direction:
      "相談者キャラクター、先生キャラクター、吹き出し、手続き図解を使って難しい制度を理解しやすくする。",
  },
  {
    pattern: "review",
    skillName: "お客様の声・レビュー証明型",
    bg: "#f5f8ff",
    fg: "#182238",
    accent: "#5b72d6",
    keywords: ["口コミ", "実績", "事例", "声", "許可"],
    requiredInfo: ["掲載可能なお客様の声", "相談事例", "地域・業種・課題・結果", "Google口コミなど第三者評価"],
    sensitiveInfo: ["お客様の声の掲載許可", "実績件数", "事例の匿名化"],
    direction:
      "相談前の悩み、依頼理由、解決結果、Google口コミ、手書きアンケートを中心に、第三者証明で信頼を作る。",
  },
  {
    pattern: "hub",
    skillName: "専門ハブ・内部リンク型",
    bg: "#f7f9fb",
    fg: "#172033",
    accent: "#476582",
    keywords: ["在留", "ビザ", "建設", "相続", "専門", "ハブ"],
    requiredInfo: ["関連手続き一覧", "内部リンクさせる専門ページ", "ケース別の導線", "記事・FAQで補足する内容"],
    sensitiveInfo: ["対応外業務", "制度改正情報の更新方針", "料金・実績の掲載可否"],
    direction:
      "手続き別、ケース別、料金、FAQ、関連記事へ分岐させるハブページ。SEO資産として下層ページへの導線を強くする。",
  },
  {
    pattern: "diagnosis",
    skillName: "無料診断・リード獲得型",
    bg: "#f2fbff",
    fg: "#123044",
    accent: "#0d91a5",
    keywords: ["診断", "取れるか", "要件", "不許可", "無料相談"],
    requiredInfo: ["診断で確認する項目", "要件チェックの内容", "無料/有料相談の条件", "診断後の案内先"],
    sensitiveInfo: ["許可可否の断定禁止", "無料相談の範囲", "個人情報取得の範囲"],
    direction:
      "自分のケースで進められるかを確認したい人向けに、要件チェック、無料診断、資料請求、相談フォームを中心に置く。",
  },
];

export function selectPagePreviewPatterns(input: {
  pageTitle?: string | null;
  h1?: string | null;
  keyword?: string | null;
  primaryValuePattern?: string | null;
  secondaryValuePatterns?: string | null;
  officeStrengths?: string[];
}): PagePreviewPattern[] {
  const haystack = [
    input.pageTitle,
    input.h1,
    input.keyword,
    input.primaryValuePattern,
    input.secondaryValuePatterns,
    ...(input.officeStrengths ?? []),
  ].filter(Boolean).join(" ");
  const scored = PAGE_PREVIEW_PATTERNS.map((pattern, index) => {
    let score = 10 - index * 0.05;
    for (const token of pattern.keywords) {
      if (haystack.includes(token)) score += 4;
    }
    if (input.primaryValuePattern?.includes(pattern.skillName.replace(/型$/, ""))) score += 6;
    return { pattern, score };
  }).sort((a, b) => b.score - a.score);
  const picked: PagePreviewPattern[] = [];
  for (const item of scored) {
    if (!picked.some((p) => p.pattern === item.pattern.pattern)) picked.push(item.pattern);
    if (picked.length === 3) break;
  }
  return picked;
}

export function previewPatternInfo(patternName: string): PagePreviewPattern | undefined {
  return PAGE_PREVIEW_PATTERNS.find((pattern) => pattern.pattern === patternName);
}
